import React, { useId, useState } from "react";
import { SideDrawer, SideDrawerCloseButton } from "@dmc/ui";
import { InputEditVer1 } from "../UI/InputEditVer1";
import User from "../../api/User";
import { observer } from "mobx-react-lite";
import { SiteFormField } from "../UI/SiteFormField";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";

export const NewRoleModal = observer(({ setVisibleNewRole }) => {
  const titleId = useId();
  const [body, setBody] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const addRoleFunc = async () => {
    if (isSubmitting) {
      return;
    }
    if (body.length < 3) {
      return alert("Слишком короткое имя роли");
    }
    setIsSubmitting(true);
    try {
      await User.addRole(body);
      setBody("");
      setVisibleNewRole(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const closedContainerNewRole = () => {
    if (isSubmitting) {
      return;
    }
    setVisibleNewRole(false);
    setBody("");
  };

  return (
    <SideDrawer
      open
      onClose={closedContainerNewRole}
      title="Новая роль"
      titleId={titleId}
      usePortal={false}
      toolbar={<SideDrawerCloseButton onClick={closedContainerNewRole} title="Закрыть" />}
      footer={
        <>
          <BtnPrimaryv4
            text={isSubmitting ? "Добавление…" : "Добавить роль"}
            onClick={addRoleFunc}
          />
          <BtnOutlineV4 text="Отмена" onClick={closedContainerNewRole} />
        </>
      }
    >
      <div className="site-modal-body">
        <SiteFormField label="Название роли">
          <InputEditVer1
            className="site-form-control"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Введите имя роли"
          />
        </SiteFormField>
      </div>
    </SideDrawer>
  );
});
